import { Component, OnInit, ViewChild } from '@angular/core';
import { VehiclesService } from 'app/services/vehicle/vehicles.service';
import { MatDialog } from '@angular/material/dialog';
import { EditComponent } from './edit/edit.component';
import { Vehicle } from 'app/models/vehicle.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
declare const swal: any;

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css']
})
export class VehiclesComponent implements OnInit {

  title: string = 'Vehiculos';
  menu: any[] = [
    {item: 'Nuevo', path: ''}
  ];
  displayedColumns = ['registerNumber', 'brand', 'model', 'year', 'update', 'delete']
  vehicles: Vehicle[] = [];
  vehicle: Vehicle;
  vehiclesDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) vehiclesPaginator: MatPaginator;
  
  constructor(private vehicleService: VehiclesService, private dialog: MatDialog) { }

  // obtener vehiculos
  async getVehicles(){
    this.vehicles = await this.vehicleService.getVehicles();
    this.vehiclesDataSource = new MatTableDataSource<any>(this.vehicles);
    this.vehiclesDataSource.paginator = this.vehiclesPaginator;
    console.log('Vehicles loaded!');
    
  }

  ngOnInit() {
    // this.refresh();
  }

  async ngAfterViewInit(){
    await this.refresh()
  }

  async refresh(){
    await this.getVehicles();
    this.vehicle = new Vehicle();
    this.vehicle = {
      id: null, 
      // year: null, 
      // registerNumber: null,
      model: {
        brand: null
      }
    }
    console.log(this.vehicle);
  }

  openEdit(){
    const dialogRef = this.dialog.open(EditComponent, {
      // width: '250px',
      data: {
        capacity: this.vehicle.capacity,
        year: this.vehicle.year,
        registerNumber: this.vehicle.registerNumber,
        model: this.vehicle.model,
        id: this.vehicle.id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialogo cerrado', result);
      this.refresh();
    })
  }

  updateVehicle(vehicle: Vehicle){
    console.log(vehicle.id);
    this.vehicle = vehicle;
    this.vehicle.id = vehicle.id;
    this.openEdit();
  }

  delete(){
    console.log("Method not implemented yet!");
  }

}
